import React from 'react';
import PropTypes from 'prop-types';
import { SummaryRing } from './sectionShared';
import { IssueTable, RiskTable } from './riskRegisterTables';

const getRiskTabKey = (tab) => {
  const normalized = String(tab || '')
    .toLowerCase()
    .replace(/\s+/g, '');
  return `risk-tab-${normalized}`;
};

const RiskTabs = ({ visibleTabs, activeRiskTab, setActiveRiskTab }) => (
  <div className="tabs-container">
    {visibleTabs.map((tab) => (
      <button
        key={getRiskTabKey(tab)}
        type="button"
        className={`tab-btn ${tab === activeRiskTab ? 'active' : ''}`}
        onClick={() => setActiveRiskTab(tab)}
      >
        {tab}
      </button>
    ))}
  </div>
);

const RiskSummary = ({ activeRiskTabKey, summaryConfig, riskRingData }) => (
  <div className={`risk-summary display-none risk-summary-v2 ${activeRiskTabKey}`}>
    <div className="summary-box total-card">
      <div className="total-ring">
        <SummaryRing segments={riskRingData} />
        <div className="total-text">
          <span>Total</span>
          <strong>{summaryConfig.total}</strong>
        </div>
      </div>
      <div className="total-breakdown">
        {summaryConfig.breakdown.map((item) => (
          <div key={item.label} className="breakdown-item">
            <span className={`dot ${item.dot}`} />
            <span>{item.label}</span>
            <strong>{item.value}</strong>
          </div>
        ))}
      </div>
    </div>

    {summaryConfig.cards.map((item) => (
      <div key={item.label} className="summary-box">
        <div className={`icon-box ${item.color}`}>
          <span className="icon">{item.icon}</span>
          <span className="icon-label">{item.label}</span>
          <span className="icon-count">{item.value}</span>
        </div>
      </div>
    ))}
  </div>
);

RiskTabs.propTypes = {
  visibleTabs: PropTypes.arrayOf(PropTypes.string).isRequired,
  activeRiskTab: PropTypes.string.isRequired,
  setActiveRiskTab: PropTypes.func.isRequired,
};

RiskSummary.propTypes = {
  activeRiskTabKey: PropTypes.string.isRequired,
  summaryConfig: PropTypes.shape({
    total: PropTypes.number,
    breakdown: PropTypes.array,
    cards: PropTypes.array,
  }).isRequired,
  riskRingData: PropTypes.array.isRequired,
};

export {
  IssueTable,
  RiskTable,
  RiskTabs,
  RiskSummary,
};

